const Info = () => {
    return (
        <div className="news ml-20">
            <div className='w-72 h-44 rounded-2xl vision'>
                <h2 className='text-center font-bold'>Vision</h2>
                <h4 className='text-center'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Totam, cum, atque sint libero sit incidunt laborum culpa quidem! Voluptas suscipit nostrum voluptatibus ducimus commodi itaque beatae.</h4>
            </div>
            <div className="w-72 h-44 rounded-2xl mision">
                <h2 className="text-center font-bold">Mision</h2>
                <h4 className="text-center">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Totam, cum, atque sint libero sit incidunt laborum culpa quidem! Voluptas suscipit nostrum voluptatibus ducimus commodi itaque beatae.</h4>
            </div>
        </div>
    );
}

export default Info;